import { useNavigate } from "react-router";
interface TermsCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

export const TermsCheckbox = ({ checked: _checked, onChange: _onChange }: TermsCheckboxProps) => {
  const navigate = useNavigate();
  const handleTermsClick = () => {
    navigate('/profile/terms-and-conditions');
  };
  const handlePrivacyClick = () => {
    navigate('/profile/privacy-policy');
  };
  return (
    <div className="space-y-3">
      <div className="flex items-start gap-3">
        {/* Terms Text (mandatory; no checkbox) */}
        <div className="flex-1 text-sm text-gray-700 leading-relaxed">
          <span>By signing in, you agree to our </span>
          <button
            onClick={handleTermsClick}
            className="text-primary-blue font-semibold hover:text-primary-blue/80 underline"
          >
            Terms & Conditions
          </button>
          <span> and </span>
          <button
            onClick={handlePrivacyClick}
            className="text-primary-blue font-semibold hover:text-primary-blue/80 underline"
          >
            Privacy Policy
          </button>
        </div>
      </div>
    </div>
  );
};